export default "__VITE_ASSET__Bl8NHkVm__"